import { useState, useMemo } from 'react';
import { createTheme } from '@mui/material/styles';
import { lightTheme, darkTheme } from './index';

// Shared theme hook for login pages that uses cookies instead of user preferences
export const useSharedTheme = () => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Check cookie first, default to light mode
    const savedTheme = document.cookie
      .split('; ')
      .find(row => row.startsWith('leadforge_login_theme='))
      ?.split('=')[1];
    return savedTheme ? savedTheme === 'dark' : false; // Default to light mode
  });

  const toggleTheme = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    // Save to cookie with 30 days expiration
    const expires = new Date();
    expires.setTime(expires.getTime() + (30 * 24 * 60 * 60 * 1000));
    document.cookie = `leadforge_login_theme=${newMode ? 'dark' : 'light'}; expires=${expires.toUTCString()}; path=/`;
  };

  const theme = useMemo(
    () => isDarkMode ? darkTheme : lightTheme,
    [isDarkMode]
  );

  return { isDarkMode, toggleTheme, theme };
};
